import 'is-in-viewport'

const animateInViewportClasses = [
  'move-up-in-viewport',
  'move-down-in-viewport',
  'move-left-in-viewport',
  'move-right-in-viewport',
  'fade-in-in-viewport',
  'zoom-in-in-viewport',
  'active-in-viewport',
  'full-width-in-viewport',
  'animate-in-in-viewport',
  'slide-in-in-viewport',
]

let didScroll = false
let scrollTimeout

$(function () {
  animateInViewport(200)
  // updateStyle()
})

export function onScroll() {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function () {
      animateInViewport()
      didScroll = true
      scrollTimeout = null // Reset timeout
      // updateStyle()
    }, 100) // Delay in milliseconds
  }
}

$(window).scroll(onScroll)
export function animateInViewport(timeout) {
  $(animateInViewportClasses.map((cls) => `.${cls}`).join(','))
    .filter(':not(.wait-to-animate)')
    .each(function () {
      const $this = $(this)

      if ($this.is(':in-viewport')) {
        if (timeout > 0) {
          setTimeout(() => $this.addClass('active'), timeout)
        } else {
          $this.addClass('active')
        }
      }
    })
}
